export enum PatentDateTypeEnum {
    Publication = 0,
    Priority = 1,
    Filing = 2,
    Grant = 3
}